import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExhibitorProfileService {

  constructor(private http: HttpClient) { }


  getProfile(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHIBITOR_PROFILE.GET_PROFILE + '/' + dataIn.catalogueId + '/reports/exhibitorProfile/' + dataIn.exhibitorId;

    return this.http.get(url);

  }

  saveProfile(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHIBITOR_PROFILE.SAVE_PROFILE;

    return this.http.put(url, dataIn);

  }


  getLoginData(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.EXHIBITOR_PROFILE.GET_LOGIN_DATA + '/' + dataIn.exhibitorId + '?userName=' + dataIn.catalogueUserName;

    return this.http.get(url);

  }




}
